import React from 'react';
import { classNames } from 'helpers';
import './Container.scss';

export const Container = props => {
  const { className, children } = props;
  const classes = classNames('container', className);
  return <div className={classes}>{children}</div>;
};
